import React, { JSX } from "react";
import { useInfoBar } from "../../hooks/useInfoBar";
import { InfoBarMobile } from "./components/InfoBarMobile";
import { InfoBarDesktop } from "./components/InfoBarDesktop";
import { useTheme } from "@mui/material";
import { infoBarDesktopStyles } from "./InfoBar.styles";
export default function InfoBar(): JSX.Element {
  const infoBar = useInfoBar();
  const theme = useTheme();
  return (
    <>
      <div style={infoBarDesktopStyles(theme).hrStyle}>
        {infoBar.isMobile ? (
          <InfoBarMobile {...infoBar} />
        ) : (
          <InfoBarDesktop {...infoBar} />
        )}
      </div>
    </>
  );
}
